import { render } from "./AccountBarSkeleton.vue?vue&type=template&id=1afd6aa4&scoped=true"
import script from "./AccountBarSkeleton.vue?vue&type=script&lang=js"
export * from "./AccountBarSkeleton.vue?vue&type=script&lang=js"

import "./AccountBarSkeleton.vue?vue&type=style&index=0&id=1afd6aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd6aa4"]])

export default __exports__